import { getProfile, saveProfile, deleteProfile, getProfileById, savePermissions, getPermissions, getAllPermissionsByProfile } from '../../../shared/data-services/management-profile-service';
import { updateZonesByEmployee, getEmployeesWithZones, getAllZonesByEmployee, GetAllEmployeesWithZonesByZone, deleteZonesByEmployee, GetAllEmployeesByZone, GetAllEmployeesByAirport, bulkUpserZoneEmployee } from '../../../shared/data-services/management-zone-service';
import { getZones } from '../../../shared/data-services/zone-service';
import { getAirports } from '../../../shared/data-services/airport-service';
import { getEmployeesByZone, getAllEmployeesByZone, getUserFaceFeature, saveNewUser, updateUser } from '../../../shared/data-services/talmaid-service';

export async function getAllProfile (){
  const data = await getProfile();
  return data || [ ];
};

// export async function getemployeesByZone(ZoneId){
//   const data = await getEmployeesByZone(ZoneId);
//   return data;
// }

export async function getallemployeesWithZones(ZoneId,companyId){
  const data = await GetAllEmployeesWithZonesByZone(ZoneId,companyId);
  return data;
}

export async function getallemployeesByAirportForEdit(ZoneId,companyId){
    const data = await GetAllEmployeesByAirport(ZoneId,companyId);
    return data;
  }

 export async function getAllZones (){
   const data = await getZones();
   return data;
 };

 // export async function getEmployees (){
 //   const data = await getEmployeesWithProfiles();
 //   return data || [ ];
 // };
 
 export async function getEmployees (companyId){
     const data = await getEmployeesWithZones(companyId);
     return data || [ ];
   };
 



// export async function updateAllProfilesByEmployee (profiles){
//   await updateProfilesByEmployee(profiles);
//   return;
// };

export async function updateAllZonesByEmployee (zones, employee){
    await updateZonesByEmployee(zones, employee);
    return;
};

// export async function getProfilesByEmployee (employeeId){
//   const data = await getAllProfilesByEmployee(employeeId);
//   return data || [ ];
// };

export async function getZonesByEmployee (employeeId){
    const data = await getAllZonesByEmployee(employeeId);
    return data || {};

  };

export async function getSelectedProfile (id){
  const data = await getProfileById(id);
  return data;
};

export async function saveSelectedProfile (id, description){
  const Profile = {
    id, 
    description
  }

  const data = await saveProfile(Profile);
  return data;
};


export async function getPermissionByProfile (profileId){
  const data = await getAllPermissionsByProfile(profileId);
  return data || [ ];
};

export async function getAllPermissions(){
  const data = await getPermissions();
  return data || [];
};


export async function saveSelectedPermissions (permissions, profileId, profileName, action){
  // const Permission = {
  //   code, 
  //   description: description
  // }
  if(action === 'CREAR'){
    profileId = null
  }
  const data = await savePermissions(permissions, profileId, profileName);
  return data;
};

export async function deleteZones (id, employee){
  const data = await deleteZonesByEmployee(id, employee);
  return data;
};

export async function bulkAssignZones(employeeIds, zones, employee){
  const data = await bulkUpserZoneEmployee(employeeIds, zones, employee);
  return data;
};

export async function getAllAirports (companyId){
  const data = await getAirports(companyId);
  return data;
};